import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const DEFAULT_LOCALE = 'tr'
export const SUPPORTED_LOCALES = ['tr', 'en']
// Intl.NumberFormat için dil → bölge eşlemesi
export const NUMBER_LOCALES = {
  tr: 'tr-TR',
  en: 'en-US',
}

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export function storedLocale() {
  const locale = localStorage.getItem('locale')
  return SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE
}

export default new VueI18n({
  locale: storedLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: loadLocaleMessages(),
  // Geliştirmede eksik anahtar uyarıları taşınmamış metinleri gösterir
  silentTranslationWarn: process.env.NODE_ENV === 'production',
})
